import { HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AuthService } from "app/services/auth.service";
import { ApiGateway } from "api/api-gateway";

@Injectable()
export class LoginService {
    constructor(private apiGateway: ApiGateway, private authService: AuthService) { }

    autenticate(credenciais): Promise<any> {
        return new Promise((resolve, reject) => {
            this.authService
                .patientLogin(credenciais)
                .subscribe((res: HttpResponse<any>) => {
                    if (res.body) {
                        resolve(res.body);
                    } else {
                        resolve(res);
                    }
                }, reject);
        });
    }
    

    enterprise(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.apiGateway
                .get("parameter/app")
                .subscribe({
                    next: (res: HttpResponse<any>) => {
                        if (res.body) {
                            resolve(res.body);
                        } else {
                            resolve(res);
                        }
                    },
                    error: (err) => {
                        reject(err);
                    }
                });
        });
    }

    enterpriseLogo(): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.apiGateway
                .get("parameter/name/LOGO_DEFAULT")
                .subscribe({
                    next: (res: HttpResponse<any>) => {
                        console.log("🚀 ~ LoginService ~ enterpriseLogo ~ res:", res)
                        if (res.body) {
                            resolve(res.body);
                        } else {
                            resolve(res);
                        }
                    },
                    error: (err) => {
                        reject(err);
                    }
                });
        });
    }

    getInfoCompany(eartefactId): Promise<any> {
        return new Promise((resolve, reject) => {
                 this.apiGateway
                .get(`user/infoCompany/${eartefactId}`)
                .subscribe({
                    next: (res: HttpResponse<any>) => {                   
                        if (res.body) {
                            resolve(res.body);
                        } else {
                            resolve(res);
                        }
                    },
                    error: (err) => {
                        reject(err);
                    }
                });
        });
    }
}
